const Config = {
    BACKEND_URL : process.env.REACT_APP_BACKEND_URL,
    WEB_SOCKET_URL:process.env.WS_URL,
    WS_PATH:'/socket.io/board',
    key: process.env.REACT_APP_KEY,
    iv: process.env.REACT_APP_IV,
};
export default Config;
  